<template>
<body class="az-body">
    <div class="az-error-wrapper">
      <div 
      style="width:500px;height:100px"
      v-loading="true" 
      element-loading-text="Redirecting to the Dashboard..."
      element-loading-spinner="el-icon-loading"
      >
      </div>
    </div>
  </body>
</template>
<script>
import base from '../request/api/base'
export default {
    data(){
        return{
            code:window.location.href.split('?code=')[1].split('=')[0],
            re:'',
            href:base.frontend+'/'
        }
    },
    mounted(){
        this.$store.dispatch('login', { 'code':this.code })
       .then(() => this.$router.push({ redirect: window.location.href = this.href }))
       .catch(err => console.log(err))
        // axios({url: 'http://127.0.0.1:8000/callback/', data: {'code':this.code}, method: 'POST' })
        //   .then(resp => {
        //     this.re = resp.data;
        // })
    }

}
</script>